
angular.module('mtic.components.mticAlertModal', [])
.component('mticAlertModal', {
  templateUrl: 'template.html',
  bindings: {},
  controller(MticAlertModalService, $scope, language) {
    $scope.alert = MticAlertModalService
    $scope.getTranslation = function(id){
      return language.get(id);
    }
  }
})
